export default __webpack_public_path__ + "static/media/portadavideoseguimiento4.9e5882ee.png";